export const REQUEST_CREDIT_CARDS = 'REQUEST_CREDIT_CARDS'
export const RECEIVE_CREDIT_CARDS = 'RECEIVE_CREDIT_CARDS'

const requestCreditCards = () => ({
  type: REQUEST_CREDIT_CARDS
})

const receiveCreditCards = cards => ({
  type: RECEIVE_CREDIT_CARDS,
  cards
})

export const fetchCreditCards = personId => dispatch => {
  dispatch(requestCreditCards())

  return fetch(process.env.REACT_APP_BASE_URL + '/payments/get_payment_cards',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      },
      body: JSON.stringify({ personId })
    })
    .then(
      response => response.json(),
      error => console.log('An error occurred', error)
    )
    .then(json => dispatch(receiveCreditCards(json)))
}

export const addCreditCard = (personId, cardNumber, expirationDate, cardHolderName) => dispatch => (
  fetch(process.env.REACT_APP_BASE_URL + '/payments/add_payment_card',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      },
      body: JSON.stringify({ personId, cardNumber, expirationDate, cardHolderName })
    }
  ).then( // re-fetching cards after adding a new one
    () => dispatch(fetchCreditCards(personId))
  )
)
